import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { columbusAgenda } from './columbusAgenda';
import { columbusDetailAgenda } from './columbusDetailAgenda';
import { ColumbusShellPage } from './ColumbusShellPage';
import { ColumbusDetailPage } from './ColumbusDetailPage';
import { COLUMBUS_PERMISSION } from './permissions';

export function ColumbusSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [
      {
        agenda: columbusAgenda,
        component: ColumbusShellPage,
        permission: COLUMBUS_PERMISSION,
      },
      {
        agenda: columbusDetailAgenda,
        component: ColumbusDetailPage,
        permission: COLUMBUS_PERMISSION,
      },
    ],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={columbusAgenda} />;
}
